/* Druckelite24 – kleine Korrekturen am Produktformular (19.10.2026).
 * Größenlauf „In den Warenkorb“ hing bei Modellen mit eigenen Größen (z. B. KG Eule „SOL'S Imperial Kids“):
 * Das Modell wurde zuerst umgestellt und dann auf die passende Variante gewartet – Kids/XS gibt es aber nicht,
 * die Variante blieb leer und das Warten lief ins Leere. Jetzt werden erst alle Optionen (Modell, Größe) gesetzt,
 * danach wird auf die fertige Variante gewartet. */
(function () {
  'use strict';
  if (!window.customElements) return;
  customElements.whenDefined('de24-product-service').then(function () {
    var C = customElements.get('de24-product-service');
    if (!C || C.prototype.__de24OptionFix) return;
    C.prototype.__de24OptionFix = 1;
    C.prototype.selectBulkVariant = async function (variant, extra) {
      var self = this;
      var radioFor = function (index) {
        var field = self.querySelectorAll('variant-picker .variant-picker__option')[index];
        return Array.prototype.slice.call((field || self).querySelectorAll('input[type="radio"]')).find(function (input) {
          return input.form === self.form && Array.prototype.slice.call(input.labels || []).some(function (label) { return label.textContent.trim() === variant.options[index]; });
        });
      };
      if (String(self.variant && self.variant.id) !== String(variant.id)) {
        for (var index = 0; index < variant.options.length; index++) {
          var radio = radioFor(index);
          if (!radio) throw new Error(self.bulkStrings('bulk_unavailable'));
          if (radio.checked) continue;
          radio.click();
          var i = index;
          await self.waitForBulk(function () { var r = radioFor(i); return !!(r && r.checked); }, 8000);
        }
      }
      await self.waitForBulk(function () {
        var id = self.form && self.form.elements.namedItem('id');
        return String(self.variant && self.variant.id) === String(variant.id) && String(id && id.value) === String(variant.id) && self.nativeQuantity() && self.nativeQuantity().isConnected && self.nativeSubmit() && self.nativeSubmit().isConnected;
      });
      await self.waitForBulk(function () { return self.appReadyFor(variant, extra); });
    };
  });
})();

/* Conversion-Helfer laden (21.10.2026): Angebots-Zählung, Fenster nach "In den Warenkorb", Kasse-Balken im Warenkorb */
(function () {
  var cs = document.currentScript;
  if (!cs || !cs.src || window.__de24Conv) return;
  window.__de24Conv = 1;
  var s = document.createElement('script');
  s.src = cs.src.split('?')[0].replace(/de24-fixes\.js$/, 'de24-conversion.js') + '?v=20261021-14';
  s.defer = true;
  document.head.appendChild(s);
  var h = document.createElement('script');
  h.src = s.src.replace('de24-conversion.js', 'de24-head.js');
  h.defer = true;
  document.head.appendChild(h);
})();
/* Anfrage-Formulare (31.10.2026): Nachricht beginnt nur mit "Anfrage", Feld "Verein / Firma", keine Sportart */
(function () {
  if (window.__de24AnfrageFix) return;
  window.__de24AnfrageFix = 1;
  var RX = /^Angebotsanfrage( Teamsport)?(?=\n|$)/;
  function fixText(t) { return typeof t === 'string' ? t.replace(RX, 'Anfrage').replace(/(^|\n)Verein \/ Team: /, '$1Verein / Firma: ') : t; }
  function tidy() {
    document.querySelectorAll('.de24-anfrage-label').forEach(function (l) {
      var n = l.firstChild;
      if (n && n.nodeType === 3 && /^Verein, Team oder Firma\s*$/.test(n.nodeValue)) n.nodeValue = 'Verein / Firma ';
    });
    document.querySelectorAll('.de24-anfrage-input[data-key="Sportart"]').forEach(function (i) {
      i.value = '';
      var l = i.closest('label');
      if (l) l.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy); else tidy();
  document.addEventListener('submit', function (e) {
    var p = e.target && e.target.querySelector && e.target.querySelector('.de24-anfrage-payload');
    if (p) p.value = fixText(p.value);
  });
  var open = window.open;
  window.open = function (url) {
    if (typeof url === 'string' && url.indexOf('wa.me/') !== -1 && url.indexOf('?text=') !== -1) {
      var i = url.indexOf('?text=') + 6;
      try { url = url.slice(0, i) + encodeURIComponent(fixText(decodeURIComponent(url.slice(i)))); } catch (err) {}
      arguments[0] = url;
    }
    return open.apply(window, arguments);
  };
})();
/* Liefertermine auf dem Handy (01.11.2026): Größen ohne Bestand zeigen wieder „Lieferfenster …“ bzw. KW – die normale Verfügbarkeit bleibt auf dem Handy ausgeblendet */
(function () {
  if (window.__de24LieferFix) return;
  window.__de24LieferFix = 1;
  var s = document.createElement('style');
  s.textContent = '.de24-product-shell .de24b-size.is-unavailable .de24b-stock{display:block!important;font-size:9.5px;line-height:1.2;margin:0 0 3px;white-space:normal}';
  document.head.appendChild(s);
})();
/* Liefertermin kurz (01.11.2026): „LT: ab 16. Nov.“ statt „Lieferfenster: 16.–20. Nov. 2026“ – auch wenn die Produktseite die Zeile per Skript neu setzt */
(function () {
  if (!window.customElements || window.__de24LtFix) return;
  window.__de24LtFix = 1;
  function lt(w) {
    w = String(w || '').trim();
    var m = w.split('–');
    if (m.length < 2) return 'LT: ' + w.replace(/^Liefertermin\s+/, '');
    var from = m[0].trim(), rest = m[1].trim().split(/\s+/), year = rest[rest.length - 1];
    var txt = 'ab ' + (from.indexOf(' ') > -1 ? from : from + ' ' + (rest[1] || ''));
    if (/^\d{4}$/.test(year) && year !== String(new Date().getFullYear())) txt += ' ' + year;
    return 'LT: ' + txt.trim();
  }
  customElements.whenDefined('de24-product-service').then(function () {
    var C = customElements.get('de24-product-service');
    if (!C || !C.prototype.stockLabel || C.prototype.__de24Lt) return;
    C.prototype.__de24Lt = 1;
    var orig = C.prototype.stockLabel;
    C.prototype.stockLabel = function () {
      var s = orig.apply(this, arguments);
      if (typeof s !== 'string') return s;
      if (s.indexOf('Lieferfenster: ') === 0) return lt(s.slice(15));
      if (s.indexOf('wieder verfügbar ab KW ') === 0) return 'LT: ab KW ' + s.slice(23);
      return s;
    };
  });
})();
